import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, FormText } from 'react-bootstrap';
import SearchTextInput from '../inputs/SearchTextInput';
import WithTranslation from '../../../hocs/WithTranslation';

class BasicSearchText extends Component {
    static propTypes = {
        showBottomBorder: PropTypes.bool,
        input: PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.string,
            onChange: PropTypes.func
        }).isRequired,
        meta: PropTypes.object.isRequired,
        label: PropTypes.string,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        icon: PropTypes.string,
        onClear: PropTypes.func,
        onSubmit: PropTypes.func,
        displayHelp: PropTypes.bool,
        className: PropTypes.string,
        disabled: PropTypes.bool
    };

    getGroupClassName = () => {
        const { required, className, icon } = this.props;
        return cns(className, {
            required,
            hasIcon: icon
        });
    };

    getFeedbackMessage = () => {
        const { touched, error, warning } = this.props.meta;
        let message = '';
        if (touched) {
            if (error) {
                message = error;
            } else if (warning) {
                message = warning;
            }
        }
        return message;
    };

    getValidationState = () => {
        const { touched, error, warning } = this.props.meta;
        if (touched && error) {
            return 'error';
        }
        if (touched && warning) {
            return 'warning';
        }
        return null;
    };

    render() {
        const {
            label,
            input: { name, value, onChange },
            placeholder,
            icon,
            required = false,
            type = 'text',
            disabled = false,
            onClear,
            onSubmit,
            displayHelp = true,
            showBottomBorder
        } = this.props;

        let labelSection = null;
        if (label) {
            labelSection = (
                <label htmlFor={name}>
                    {label}
                    {required && <span className={'required-tag'}>*</span>}
                </label>
            );
        }

        const helpBlockSection = displayHelp ? <FormText>{this.getFeedbackMessage()}</FormText> : null;

        return (
            <Form.Group className={this.getGroupClassName()} validated={this.getValidationState()}>
                {labelSection}
                <SearchTextInput
                    onChange={onChange}
                    onClear={onClear}
                    onSubmit={onSubmit}
                    showBottomBorder={showBottomBorder}
                    value={value}
                    disabled={disabled}
                    required={required}
                    placeholder={placeholder}
                    type={type}
                    name={name}
                />
                {helpBlockSection}
                {icon ? <i className={icon} /> : null}
            </Form.Group>
        );
    }
}

export default WithTranslation(BasicSearchText);
